import { getVirtualSensors, getSensorGroups } from '@Actions';
import {
	clearSensorGroups,
	getImageList,
	getSensorGroups as getSensorGroupFromStylovyze,
	getSensorsList,
} from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations';
import { LiftStationFormFields } from '@Types';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { liftStationSchema } from '../../schemas/liftStation.schema';
import usePropagateFormikDependantStations from './hooks/usePropagateFormikDependantStations';
import UpsertLiftStationFormFields from './UpsertLiftStationFormFields';
import UpsertLiftStationImages from './UpsertLiftStationImages';
import UpsertLiftStationMap from './UpsertLiftStationMap';
import { UpsertLiftStationsFormContainer } from './UpsertLiftStationsForm.styles';

interface UpsertLiftStationFormProps {
	initialValues: LiftStationFormFields;
	onSubmit: (
		values: LiftStationFormFields,
		formikHelpers: FormikHelpers<LiftStationFormFields>,
	) => void;
	isValid?: boolean;
	setIsValid?: React.Dispatch<React.SetStateAction<boolean>>;
	stationName?: string;
	setStationName?: React.Dispatch<React.SetStateAction<string>>;
}

// eslint-disable-next-line react/display-name
const UpsertLiftStationForm = React.forwardRef<
	FormikProps<LiftStationFormFields> | undefined,
	UpsertLiftStationFormProps
>(
	(
		{
			initialValues,
			onSubmit,
			setIsValid,
			setStationName,
		}: UpsertLiftStationFormProps,
		_ref,
	) => {
		const { t } = useGlobalization();
		const dispatch = useDispatch();
		useEffect(() => {
			dispatch(clearSensorGroups());
			dispatch(getSensorGroupFromStylovyze({ limit: 1000 }));
			dispatch(getSensorsList({}));
			dispatch(
				getSensorGroups({
					limit: 1000,
					includeSensorGroupPairs: 'true',
				}),
			);
			dispatch(
				getVirtualSensors({
					sensorType: 'Volume',
					channelType: 'virtual',
				}),
			);
			dispatch(getImageList());
		}, []);

		return (
			<Formik
				onSubmit={onSubmit}
				validationSchema={liftStationSchema(t)}
				initialValues={initialValues}
				initialTouched={{ location: true }}
				enableReinitialize>
				{formikProps => {
					const ref = _ref as unknown as React.MutableRefObject<
						FormikProps<LiftStationFormFields> | undefined
					>;
					ref.current = formikProps;
					usePropagateFormikDependantStations({
						formikProps,
						setIsValid,
						setStationName,
					});
					return (
						<Form>
							<UpsertLiftStationsFormContainer>
								<UpsertLiftStationFormFields />
								<UpsertLiftStationMap />
								<UpsertLiftStationImages />
							</UpsertLiftStationsFormContainer>
						</Form>
					);
				}}
			</Formik>
		);
	},
);

export default UpsertLiftStationForm;
